export default __webpack_public_path__ + "static/media/NW0190.34I-38035_-22385_0.a114e120.jpg";